module.exports = __webpack_public_path__ + "static/img/bill_sample.a1e0134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bill_sample.png
// module id = WWNz
// module chunks = 41